import React from "react";
import { withRouter } from "us.common/wIthRouter";
import IO from "us.collection.input-output";

const Cnt_RegisterInvoice: React.FC = (props) => {
  return (
    <IO.Components.RegisterInvoice.Home
      {...props}
      history={(props as any).history}
    />
  );
};

export default withRouter(Cnt_RegisterInvoice);
